export type SupportOption = string

export const affectationKind: SupportOption[] = [
    'Lesiones visibles como moretones, fracturas o cortaduras',
    'Dolores crónicos (cabeza, espalda, abdomen)',
    'Problemas ginecológicos o sexuales',
    'Trastornos del sueño',
    'Fatiga o agotamiento constante',
    'Ansiedad o ataques de pánico',
    'Depresión o tristeza profunda',
    'Baja autoestima',
    'Sentimientos de culpa o vergüenza',
    'Miedo constante o paranoia',
    'Trastorno de estrés postraumático (TEPT)',
    'Aislamiento de amigos y familiares',
    'Estigmatización o rechazo social',
    'Desconfianza hacia otras personas',
    'Pérdida de redes de apoyo',
    'Pérdida del empleo',
    'Dependencia económica del agresor',
    'Dificultad para generar ingresos propios',
    'Endeudamiento o empobrecimiento',
    'Dolor durante las relaciones sexuales',
    'Pérdida del deseo sexual',
    'Embarazos no deseados',
    'Infecciones o enfermedades de transmisión sexual',
    'Fobia al contacto físico',
    'Revictimización durante procesos legales',
    'Falta de acceso a justicia o protección',
    'Desconfianza en instituciones públicas',
    'Procesos legales prolongados y traumáticos',
    'Pérdida del sentido de vida',
    'Crisis de fe o creencias espirituales',
    'Sentimientos de desesperanza o vacío existencial',
]

export const affectationScope: SupportOption[] = [
    'Dificultad para establecer relaciones interpersonales sanas',
    'Limitación en su desarrollo personal, académico o profesional',
    'Pérdida del proyecto de vida o metas personales',
    'Aumento del riesgo de suicidio o autolesiones',
    'Dependencia emocional o económica prolongada del agresor',
    'Crianza en contextos de violencia que perpetúan el ciclo en hijos e hijas',
    'Estigmatización y discriminación social persistente',
    'Dificultad para confiar en instituciones y acceder a servicios de salud, justicia o protección',
    'Revictimización que refuerza el trauma original',
    'Pérdida de oportunidades laborales y económicas',
    'Migración forzada o desplazamiento por razones de seguridad',
    'Deterioro permanente de la salud física o mental',
    'Pérdida de autonomía y control sobre su vida y decisiones',
    'Aislamiento social que agrava la soledad y vulnerabilidad',
    'Ruptura familiar o alejamiento de redes de apoyo',
    'Normalización de la violencia como parte de la vida cotidiana',
]

export const supportKind: SupportOption[] = [
    'Atención psicológica individual y grupal',
    'Asesoría jurídica y acompañamiento legal',
    'Protección policial y medidas de alejamiento',
    'Refugios o casas de acogida temporal',
    'Atención médica y tratamiento de lesiones',
    'Apoyo social y comunitario',
    'Acompañamiento en denuncias y procesos judiciales',
    'Orientación para la inserción laboral',
    'Asistencia económica o subsidios temporales',
    'Educación y talleres de empoderamiento',
    'Asistencia para reubicación si es necesario',
    'Orientación sobre derechos humanos y género',
    'Acceso a programas de vivienda',
    'Capacitación para emprendimiento o empleo',
    'Apoyo para el restablecimiento de vínculos familiares',
]

export const remaningSupport: SupportOption[] = [
    'Falta de atención psicológica especializada',
    'Ausencia de acompañamiento jurídico gratuito',
    'No hay rutas claras de denuncia',
    'No hay casas refugio disponibles en la zona',
    'Falta de apoyo económico de emergencia',
    'Desconocimiento de los derechos de la víctima',
    'Poca articulación entre instituciones de ayuda',
    'Demora en activar medidas de protección',
    'No hay programas de empleabilidad para víctimas',
    'Falta de seguimiento a los casos reportados',
]
